import PropTypes from 'prop-types'
import styled from 'styled-components'

const StyledWrapper = styled.div`
  display: inline-flex;
  z-index: 1;
  gap: 16px;
`

const FiltersSection = ({ children, className }) => {
  return (
    <StyledWrapper className={className}>
      {children}
    </StyledWrapper>
  )
}

FiltersSection.propTypes = {
  children: PropTypes.node,
}

export default FiltersSection
